import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'
import { OppSummary } from './typings'
import {
  ISearchResponse,
  pageToSearchInput,
  searchInputToQueryString,
} from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.opportunity.opportunity}${ServiceConfig.opportunity.location}`

export const getLocationOpps = createAsyncThunk<
  ISearchResponse<OppSummary>,
  { externalLinkId: string; page: number; perPage: number }
>('oppSummary/location', async ({ externalLinkId, page, perPage }) => {
  const qstring = searchInputToQueryString(pageToSearchInput(page, perPage))
  const response = await get(`${baseUrl}/${externalLinkId}?${qstring}`)
  if (response.ok) return await response.json()
})
